<template>
  <v-card class="mx-auto" outlined>
    <v-list two-line>
      <!-- ชื่อและสังกัด -->
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ personnel.frist_names || "-" }}</v-list-item-title>
          <v-list-item-subtitle>
            ปัจจุบัน: {{ personnel.college_name || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset />

      <!-- ตำแหน่ง -->
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-clipboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ตำแหน่ง</v-list-item-title>
          <v-list-item-subtitle>
            {{ personnel.name_postion || "-" }} - {{ personnel.rang_name || "-" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- เลขที่ตำแหน่ง -->
      <v-list-item>
        <v-list-item-action />
        <v-list-item-content>
          <v-list-item-title>เลขที่ตำแหน่ง</v-list-item-title>
          <v-list-item-subtitle>{{ personnel.id_position || "-" }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset />

      <!-- วันที่บรรจุ -->
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-map-marker</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>วันที่บรรจุ</v-list-item-title>
          <v-list-item-subtitle>{{ personnel.date_app || "-" }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "PersonnelInfoCard",
  
  props: {
    personnel: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>